export const SET_MOBILE = 'setMobile';
export const SET_MENU = 'setMenu';